import React from 'react';
import '../style/Unsplash.css'
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import { ArchiveFilterBar } from './ArchiveFilterBar';
import '../style/DownloadFileOverlay.css';

const MY_ACCESS_KEY = "2481e8fefcab0eb5996904a74156419cac77f5eb9d5647c2e943a6b71f9e74e5"

class UnsplashPlugin extends React.Component {
  state = {
    files: [],
    matches: 0
  }
  componentDidMount() {
    this.download();
  }
  download() {
    fetch('https://api.unsplash.com/photos/?query=event&page=10&per_page=100&client_id=' + MY_ACCESS_KEY)
      .then(res => res.json())
      .then(data => {
        this.setState({ files: data, matches: data.length })
      })
      .catch(err => {
        console.log('Error happened during fetching!', err);
      });
  }

  filter = (str) => {
    if (str !== "" && str.length >= 3) {
      fetch(`https://api.unsplash.com/search/photos/?query=${str}&page=2&per_page=100&client_id=${MY_ACCESS_KEY}`)
        .then(res => res.json())
        .then(data => {
          this.setState({ files: data.results, matches: /* data.total */data.results.length })
        })
        .catch(err => {
          console.log('Error happened during fetching!', err);
        });
    }
    else {
      this.download();
    }
  }
  onMouseEnter = (file) => {
    this.props.onSelect(file, true)
  }
  onMouseLeave = () => {
    this.props.onSelect(null, true)
  }
  render() {
    const { files } = this.state;
    const { unsplashFile, onSelect, download } = this.props;
    return (
      <div>
        <Container className="grid-container display-type">
          <ArchiveFilterBar
            filterFiles={this.filter}
            result={this.state.matches} />
        </Container>

        <Container className="grid-container">

          <Row className="grid-item-wrapper" >
            {files && files.length > 0 && files.map((f, i) => {
              return (
                <Col key={i} 
                  className={`image-slot grid-item `}>
                  <Row className="preview-image-wrapper">
                    <div className="archive-download-container">
                      <img
                        src={f.urls.small}
                        alt="_blank"

                        className="preview-image archive-download-content" />
                      <div onMouseEnter={() => this.onMouseEnter(f)}
                        onMouseLeave={() => this.onMouseLeave} className="archive-download-overlay">
                        <span href="#" className="archive-download-icon" title="image">
                          <i onClick={() => download(f)} className="fa fa-download"></i>
                        </span>
                      </div>{/* } */}
                    </div>
                  </Row>
                  <div >
                    <Row
                      className='preview-info'>
                      <span className="text-muted info-text" >
                        {f.height + 'x' + f.width}
                      </span>
                      <span
                        className="text-muted info-text" >
                        <i className="fa fa-person" /> {"  "}
                        {f.user.name}
                      </span>
                      <span className="text-muted info-text">
                        <i className="fa fa-instagram" /> {"  "} {f.user.instagram_username}
                      </span>
                    </Row>
                  </div>
                </Col>
              )
            })}
          </Row>
        </Container>
      </div>
    )
  }
}

export default UnsplashPlugin;
